import { JsonObject, JsonProperty } from 'json-ts-mapper';
import { CommandeSAS } from './commande/sas/commande-sas';

@JsonObject
export class ConfirmationCommande {
  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  numero: string;

  @JsonProperty(String, 'emailConfirmation')
  email: string;

  @JsonProperty(CommandeSAS)
  commande: CommandeSAS;
}
